export default __webpack_public_path__ + "static/media/balanceCare.e8e1c8ae.png";